
// actions
const ACTION_PREFIX = 'activityList'
const SET_ITEMS = `${ACTION_PREFIX}/SET_ITEMS`
const UPDATE_ITEM = `${ACTION_PREFIX}/UPDATE_ITEM`
const DELETE_ITEM = `${ACTION_PREFIX}/DELETE_ITEM`

// reducer
const initialState = {
  items: [],
  updateTimestamp: null,
}

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case SET_ITEMS:
      const { items } = action
      return { ...state, items, updateTimestamp: new Date().getTime() }

    case DELETE_ITEM:
      return { ...state, updateTimestamp: new Date().getTime() }

    default:
      return state
  }
};

// action creators
export const setItems = (items) => {
  return {
    type: SET_ITEMS,
    items,
  }
}
export const updateItem = (item) => {
  return {
    type: UPDATE_ITEM,
    item,
  }
}
export const deleteItem = (idToRemove) => {
  return {
    type: DELETE_ITEM,
    idToRemove,
  }
}
